<template>
  <div class="lib__infobox-list">
    <info-box :item="true" level="primary">
      <div class="lib__infobox__header__title">
        <h4 class="lib__text-weight-600" v-html="$t('meter.electricityPackage.addConnectionLabel')">
        </h4>
      </div>
      <div class="lib__infobox__header__annexe">
        <h4 class="lib__text-weight-700">{{ excludingVatPrice }}€</h4>
      </div>
      <div class="lib__infobox__header__annexe-more">
        <p v-html="$t('meter.excludingVATPrice')">
        </p>
      </div>
    </info-box>
    <info-box :item="true" level="primary">
      <ul class="lib__infobox__content__data">
        <li>
          <div>
            {{ $t('meter.form.count') }}
          </div>
          <span class="lib__text-theme lib__text-weight-700">{{ meterCount }}x {{
            $tc('meter-box.electricalMeter', meterCount)
          }}</span>
        </li>
        <li>
          <div>
            {{ $t('meter-box.functionality') }}
          </div>
          <span class="lib__text-theme lib__text-weight-700">{{ $t(selectedFunctionality) }}</span>
        </li>
      </ul>
    </info-box>
    <info-box :item="true" level="primary">
      <div class="lib__btns-nav-list">
        <button @click="onEdit(identifier)" type="button" class="lib__btn lib__btn--link lib__btn--secondary"><i
            class="fas fa-pencil-alt"></i>
          <span>{{ $t('meter-box.edit') }}</span></button>
        <button @click="onDelete(identifier)" type="button" class="lib__btn lib__btn--link lib__btn--danger"><i
            class="far fa-trash-alt"></i>
          <span>{{ $t('meter-box.delete') }}</span></button>
      </div>
    </info-box>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'add-connection-editable-box',
  components: {}
})
export default class AddConnectionEditableBox extends Vue {
  @Prop({ type: Number, required: true }) public meterCount!: number
  @Prop({ type: String, required: false }) public selectedFunctionality!: string
  @Prop({ type: Number, required: true }) public identifier!: number
  @Prop({ type: Number, required: false, default: 0 }) public excludingVatPrice!: number

  @Prop({ type: Function, required: true }) public onEdit!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public onDelete!: (identifier: number) => void

  public mounted() { }
}
</script>